import React from 'react';
import Content from '@src/components/nexa/Content';
import { useParams } from 'react-router-dom';
import { NexaWrapper } from './NexaWrapper';

const Nexa = () => {
  const { id = null } = useParams();

  return <NexaWrapper storeKey={id}>{id && <Content />}</NexaWrapper>;
};

export default Nexa;
